// src/components/Actividades.jsx
export default function Actividades() {
  return (
    <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
      <iframe
        src="https://cruzrojamex-my.sharepoint.com/personal/rizquierdo_cdmx_cruzrojamexicana_org_mx/_layouts/15/embed.aspx?UniqueId=514cda73-31c0-4845-9fc3-c5ee76468996"
        width="640"
        height="360"
        frameBorder="0"
        scrolling="no"
        allowFullScreen
        title="Mapa Cecap"
        style={{ border: 0, maxWidth: "100%" }}
      />
    </div>
  );
}
